module.exports = __webpack_public_path__ + "media/images/flags/16/Guernsey-5dd486eb20094754cb0f615b7b6997ba.png";